function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  className: "record-hi-dark_svg__976c0438-a903-4ee1-9b84-9948305f7751",
  fill: "none",
  d: "M0 0h192v192H0z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "record-hi-dark_svg__fb24a08e-a11d-439b-b0b1-43c275610b2d",
  d: "M96 16a80 80 0 0180 80 80 80 0 01-80 80 80 80 0 01-80-80 80 80 0 0180-80z",
  fill: "#fff"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "record-hi-dark_svg__f98fb761-9631-4bb0-83aa-8db7caf43678",
  d: "M96 136a39.9 39.9 0 01-26.9-10.4l47.6 47.6a80.6 80.6 0 0056.5-56.7L124 67.3h-.1A40 40 0 0196 136z",
  fill: "#f0f0f0"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  className: "record-hi-dark_svg__31d71768-138b-4fd6-b3ac-9c7f301cc33d",
  cx: 96,
  cy: 96,
  r: 40,
  fill: "#e60000"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "record-hi-dark_svg__df74a62a-2e19-458a-9ec4-ca4563757cab",
  d: "M96 134a40 40 0 01-40-39v1a40 40 0 0080 0v-1a40 40 0 01-40 39z",
  fill: "#d30514"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "record-hi-dark_svg__8946638f-346e-4cb1-92a8-7f7c77e5850e",
  d: "M87.1 114V79h10.2a8.7 8.7 0 018.7 7.2 8.5 8.5 0 01-7.1 9.7H87.1",
  fill: "none"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "record-hi-dark_svg__8946638f-346e-4cb1-92a8-7f7c77e5850e",
  d: "M95.6 96c3.6 0 6.7 1.4 7.8 4.7l4.1 13.3",
  fill: "none"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "record-hi-dark_svg__f98fb761-9631-4bb0-83aa-8db7caf43678",
  d: "M96 174a80.2 80.2 0 01-80-79v1a80.2 80.2 0 0080 80 80.2 80.2 0 0080-80v-1a80.2 80.2 0 01-80 79z",
  fill: "#f0f0f0"
});

var SvgRecordHiDark = function SvgRecordHiDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 192 192",
    "aria-hidden": true
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

export default SvgRecordHiDark;